import * as form from '../form';
import {i18n} from './i18n';

export abstract class Validator {
  constructor(protected readonly form: HTMLFormElement) {
  }
  abstract checkValidity(): boolean;
}

export class TextDateValidator extends Validator {
  static parse(value: string) {
    const matcher = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!matcher)
      return;
    const y = parseInt(matcher[1]!);
    const m = parseInt(matcher[2]!) - 1;
    const d = parseInt(matcher[3]!);
    const date = new Date(y, m, d);
    if (date.getMonth() != m || date.getDate() != d)
      return;
    return date;
  }
  checkValidity() {
    const inputs = form.Form.getControls(this.form).filter(control => {
      return control.type == 'text' && control.hasAttribute('data-date') &&
        'value' in control && control.value;
    }) as HTMLInputElement[];
    return inputs.every(input => this.checkValidityInput(input));
  }
  private checkValidityInput(input: HTMLInputElement) {
    if (TextDateValidator.parse(input.value))
      return true;
    input.classList.add('invalid-input');
    input.setCustomValidity(i18n('invalid'));
    return false;
  }
}

export class TextMonthValidator extends Validator {
  static parse(value: string) {
    const matcher = value.match(/^(\d{4})-(\d{2})$/);
    if (!matcher)
      return;
    const y = parseInt(matcher[1]!);
    const m = parseInt(matcher[2]!) - 1;
    const d = 1;
    const date = new Date(y, m, d);
    if (date.getMonth() != m)
      return;
    return date;
  }
  checkValidity() {
    const inputs = form.Form.getControls(this.form).filter(control => {
      return control.type == 'text' && control.hasAttribute('data-date') &&
        'value' in control && control.value;
    }) as HTMLInputElement[];
    return inputs.every(input => this.checkValidityInput(input));
  }
  private checkValidityInput(input: HTMLInputElement) {
    if (TextDateValidator.parse(input.value))
      return true;
    input.classList.add('invalid-input');
    input.setCustomValidity(i18n('invalid'));
    return false;
  }
}

export class PasswordValidator extends Validator {
  private readonly password: HTMLInputElement =
    this.form['user[password]'];
  private readonly confirmation: HTMLInputElement =
    this.form['user[password_confirmation]'];
  checkValidity() {
    const password = this.password.value;
    const confirmation = this.confirmation.value;
    if (password != confirmation) {
      this.setInvalid(i18n('password.different'));
      return false;
    }
    if (!/[a-zA-Z]/.test(password) || !/[0-9]/.test(password)) {
      this.setInvalid(i18n('password.conbine'));
      return false;
    }
    return true;
  }
  private setInvalid(message: string) {
    for (const input of [this.password, this.confirmation]) {
      input.classList.add('invalid-input');
      input.setCustomValidity(message);
    }
  }
}
